
import React from 'react'
import { compose } from 'widgets-shared/core'
import { withComponentContext } from 'widgets-shared/core'
import { withTranslations } from 'widgets-shared/core'
import { Grid, Typography, Button } from '@mui/material'

import { withStyles, createStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles';
import { TranslationFunction } from 'smartstream-widgets/types/sharedModule/core'
import { PropTranslations } from 'smartstream-widgets/types/widget'
import { getDefaultTheme } from 'smartstream-widgets/utils/getDefaultTheme'

type Props = {
  classes: {
    [K in string]: string
  },
  clickHandler?: (() => void),
  config: {
    BASE_ASSET_PATH: string
  },
  translations: PropTranslations,
  mobileView: boolean
}

const styles = (theme: Theme) =>  createStyles({
  cta: {
    margin: `50px auto`,
    padding: `0px 30px`,
    fontWeight: 'bold',
    minHeight: 33,
    textTransform: 'none',
    letterSpacing: 0
  },
  title: {
    fontFamily: `${theme.typography.variantFontFamily}, ${theme.typography.fontFamily}`,
    fontSize: 36,
    fontWeight: 'bold',
    marginBottom: 18
  },
  root: {
    alignItems: 'center',
    flexGrow: 1,
    padding: 34,
    '& div:first-child': {
      flexGrow: 1
    },
    '& img': {
      maxWidth: '100%'
    }
  }
})

export function MissingLink (props: Props) {
  const {
    classes,
    clickHandler,
    config: {
      BASE_ASSET_PATH
    },
    translations,
    mobileView
  } = props

  const direction = mobileView ? 'column' : 'row'

  return (
    <Grid alignItems='center' direction={direction} container wrap='nowrap' className={classes.root} justifyContent='space-between'>
      <Grid item>
        <Typography className={classes.title} variant='h1'>{translations.title}</Typography>
        <Typography>{translations.caption}</Typography>
        {
          clickHandler  &&
          <Button classes={{root: classes.cta}} onClick={() => clickHandler()} variant={'contained'} color='primary' disableElevation>
            {translations.actionButton}
          </Button>
        }
      </Grid>
      <Grid item>
        <img src={`${BASE_ASSET_PATH}/img/misslink.svg`} alt={translations.title} />
      </Grid>
    </Grid>
  )
}

export default compose(
  withComponentContext,
  withStyles(styles,{defaultTheme: getDefaultTheme}),
  withTranslations((t: TranslationFunction) => {
    return {
      caption: t('missingLink.caption.translation', {
        defaultValue: 'This elusive page may or may not have ever existed. The world may never know.',
        context: 'Caption to show alongside the missing link image'
      }),
      title: t('missingLink.title.translation', {
        defaultValue: 'You found a missing link',
        context: 'Missing link page title'
      }),
      actionButton: t('missingLink.actionButton.translation', {
        defaultValue: "Today's odds",
        context: 'actionButton text in the missing link page'
      })
    }
  })
)(MissingLink)
